import React from 'react';
import { motion } from 'framer-motion';
export function CostComparisonSection() {
  const costs = [{
    sin: 'Otro fin de semana sin plan familiar',
    costo: 'Más pantallas, menos conexión real'
  }, {
    sin: 'Conversaciones que no pasan de «¿cómo te fue?»',
    costo: 'Distancia emocional que crece cada día'
  }, {
    sin: 'Hijos que prefieren la pantalla a estar con vos',
    costo: 'Recuerdos que nunca se van a crear'
  }, {
    sin: 'Rutina que se come los mejores años',
    costo: 'Una infancia que pasa sin momentos especiales'
  }, {
    sin: 'Querer conectar pero no saber cómo',
    costo: 'Oportunidades perdidas que no vuelven'
  }, {
    sin: 'Dejar los momentos «para después»',
    costo: '«Después» nunca llega — y los hijos crecen'
  }];
  return <section className="cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-43">
      <div className="max-w-4xl mx-auto" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-46">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </motion.div>

        <div className="bg-navy-950 rounded-3xl overflow-hidden border border-navy-800 shadow-2xl" data-id="element-47">
          <div className="grid grid-cols-1 md:grid-cols-2 bg-navy-900 border-b border-navy-800" data-id="element-48">
            <div className="p-6 font-bold text-slate-300 hidden md:block" data-id="element-49">
              Sin el Pack
            </div>
            <div className="p-6 font-bold text-red-400 hidden md:block" data-id="element-50">
              Costo real
            </div>
          </div>

          <div className="divide-y divide-navy-800/50" data-id="element-51">
            {costs.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="grid grid-cols-1 md:grid-cols-2 hover:bg-navy-900/50 transition-colors" data-id="element-52">
                <div className="p-5 md:p-6 text-slate-300" data-id="element-53">
                  <span className="md:hidden font-bold text-slate-500 text-xs uppercase tracking-wider block mb-1" data-id="element-54">
                    Sin el Pack
                  </span>
                  {item.sin}
                </div>
                <div className="p-5 md:p-6 text-red-300/90 font-medium bg-red-900/10 md:bg-transparent border-t border-navy-800 md:border-t-0 md:border-l border-navy-800/50" data-id="element-55">
                  <span className="md:hidden font-bold text-red-500/50 text-xs uppercase tracking-wider block mb-1" data-id="element-56">
                    Costo real
                  </span>
                  {item.costo}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}